import { EnumField, ListField, TextField } from 'framework/ui/field';
import { SectionRow } from 'framework/ui/layout';
import VacancyPublicationOptionField from './VacancyPublicationOptionField';
import {
  VACANCY_QUESTION_TYPES,
  VACANCY_QUESTION_TYPES_ALIASES,
} from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';

const VacancyPublicationDetailsField = ({ value = {} }: { value?: any }) => {
  const formFieldType = value.type;
  const isOptionsVisible = formFieldType === VACANCY_QUESTION_TYPES_ALIASES.OPTIONS;
  return (
    <SectionRow>
      <TextField value={value.label} label="Label" />
      <TextField value={value.fieldName} label="Field name" />
      <EnumField options={VACANCY_QUESTION_TYPES} value={formFieldType} label="Field type" />
      <ListField value={value.options} label="Non-relevant options" isVisible={isOptionsVisible}>
        <VacancyPublicationOptionField />
      </ListField>
    </SectionRow>
  );
};

export default VacancyPublicationDetailsField;
